import { render, staticRenderFns } from "./empty-content-box.vue?vue&type=template&id=7f2e7fe3&scoped=true&"
import script from "./empty-content-box.vue?vue&type=script&lang=ts&"
export * from "./empty-content-box.vue?vue&type=script&lang=ts&"
import style0 from "./empty-content-box.vue?vue&type=style&index=0&id=7f2e7fe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e7fe3",
  null
  
)

export default component.exports